/**
 * Shared mutable cache for the current user's authorization state
 * (permissions). Kept in a separate module so both authProvider (which clears
 * it on logout) and accessControlProvider (which reads/writes it) can import it
 * without creating a circular dependency.
 */

export const PERMISSIONS_CACHE_TTL_MS = 30_000;

export interface PermissionsCache {
  permissions: string[] | null;
  expiresAt: number;
  inflight: Promise<string[]> | null;
}

export const permissionsCache: PermissionsCache = {
  permissions: null,
  expiresAt: 0,
  inflight: null,
};

/**
 * Clears all cached authorization state.
 * Must be called on logout to ensure stale permissions are never served after a
 * user signs out (the SPA does not hard-reload on logout).
 */
export function clearPermissionsCache(): void {
  permissionsCache.permissions = null;
  permissionsCache.expiresAt = 0;
  permissionsCache.inflight = null;
}
